import hero1 from "../../assets/slider12.jpg";
import hero2 from "../../assets/slider21.jpg";
export const HeroItems=[
    {
        img:hero1
    },
    {
        img:hero2
    }

]